import script from "./DocumentDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentDetailsModal.vue?vue&type=style&index=0&id=ecf6d4d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecf6d4d4"]])

export default __exports__